import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import  {TicketViewComponent } from "./ticket-view.component";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import {UsernameToNameModule} from "@app/pipes/username-to-name/username-to-name.module";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatIconModule} from "@angular/material/icon";
import {MatChipsModule} from "@angular/material/chips";

@NgModule({
  declarations: [TicketViewComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        UsernameToNameModule,
        MatTooltipModule,
        MatIconModule,
        MatChipsModule,
    ],
  exports: [TicketViewComponent]
})
// @ts-ignore
export class TicketViewModule { }
